<template>
	<div class="vip-promotion">
		<div style="position: absolute; left: 20px; top: 20px;">
			<van-icon color="#ffffff" size="20" name="arrow-left" style="text-shadow: 2px 2px 4px #000;" @click="navBack" />
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_01.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_02.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_03.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_04.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_05.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_06.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_07.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_08.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_09.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_10.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_11.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_12_01.jpg" style="width: 100%" alt="" @click="openWxPayService"/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_12_02.jpg" style="width: 100%" alt="" @click="openWxCustomerService"/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_12_03.jpg" style="width: 100%" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: "vippromotion",
	methods: {
		// 打开在线客服
		openWxCustomerService() {
			const screen = navigator.userAgent;
			const isAndroid = screen.indexOf('Android') > -1 || screen.indexOf('Adr') > -1;
			const isIos = !!screen.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			if (isAndroid) {
				if (!window.Android_JS) {
					this.$utils.dialog.alert("安卓方法Android_JS不存在");
					return;
				}
				if (!window.Android_JS.openWxCustomerService) {
					this.$utils.dialog.alert("请您升级训美在线至最新版本");
					return;
				}
				window.Android_JS.openWxCustomerService();
			}
			if (isIos) {
				window.webkit.messageHandlers.openWxCustomerService.postMessage(null);
			}
		},
		// 调起微信支付
		openWxPayService() {
			const screen = navigator.userAgent;
			const isAndroid = screen.indexOf('Android') > -1 || screen.indexOf('Adr') > -1;
			const isIos = !!screen.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			if (isAndroid) {
				if (!window.Android_JS) {
					this.$utils.dialog.alert("安卓方法Android_JS不存在");
					return;
				}
				if (!window.Android_JS.openWxPayService) {
					this.$utils.dialog.alert("请您升级训美在线至最新版本");
					return;
				}
				window.Android_JS.openWxPayService();
			}
			if (isIos) {
				window.webkit.messageHandlers.openWxPayService.postMessage(null);
			}
		},
		// 点击回退
		navBack() {
			if (this.$route.query.fromPage === 'AD') {
				this.$router.back();
			} else {
				// 兼容广东交信投使用原生开发的app,app定义closeWindows()方法
				if (this.$store.state.cache.screen.isAndroid) {
					console.log("调用安卓方法Android_JS", window)
					if (!window.Android_JS) {
						this.$utils.dialog.alert("安卓方法Android_JS不存在");
						return;
					}
					if (!window.Android_JS.closeWindows) {
						this.$utils.dialog.alert("安卓方法closeWindows不存在");
						return;
					}
					window.Android_JS.closeWindows();
				}
				if (this.$store.state.cache.screen.isIos) {
					console.log("调用ios方法")
					window.webkit.messageHandlers.closeWindows.postMessage(null);
				}
			}
		},
	}
}
</script>

<style scoped lang="less">
.vip-promotion {
	font-size: 0;
	margin: 0;
	padding: 0;
	.grid-row {
		font-size: 0;
	}
}
</style>
